import appConfig from '@nerdwallet/app-config';
import { extractHeaderInformation } from './redirect-utils';
import PRODUCT_TYPES from '../config/marketplace-product-types';

const SMB_SLUGS_PREFIX = '/best/small-business';

export const CC_SLUGS = [
  '/the-best-credit-cards',
  '/reviews/credit-cards',
  '/best/credit-cards',
  '/m/credit-cards',
  '/pers-rec-results',
  '/compare/credit-cards',
];

const isCCOfferFromSMB = (referrer, marketplaceOfferProductType) =>
  referrer.includes(`${appConfig.SITE_BASE_URL}${SMB_SLUGS_PREFIX}`) &&
  marketplaceOfferProductType === PRODUCT_TYPES.CREDIT_CARDS;

export const isCCCardArtEligible = (req, marketplaceOfferProductType) => {
  const { referrer } = extractHeaderInformation(req);

  if (!referrer) {
    return false;
  }

  if (isCCOfferFromSMB(referrer, marketplaceOfferProductType)) {
    return true;
  }

  return CC_SLUGS.some((slug) => {
    const url = `${appConfig.SITE_BASE_URL}${slug}`;
    return referrer.includes(url);
  });
};
